module.exports = __webpack_public_path__ + "static/img/circle_02.91c4279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle_02.png
// module id = S8u2
// module chunks = 1